import { h } from '@stencil/core';

const Icon = ({ width = '100%', height = '100%' }) => {
  return (
    <svg width={width} height={height} viewBox="0 0 79 29" fill="none" stroke="black" xmlns="http://www.w3.org/2000/svg">
      <path d="M1.3501 2.68628V25.2301L13.123 33.9972" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M23.3931 37.504L78.5003 19.2184V0.932861" stroke-linecap="round" stroke-linejoin="round" />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M36.9625 16.4747C40.2087 17.3215 41.967 21.3561 40.8897 25.4862C39.8123 29.6164 36.3073 32.278 33.061 31.4312C29.8147 30.5844 28.0565 26.5498 29.1338 22.4197C30.2112 18.2896 33.7162 15.6279 36.9625 16.4747Z"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M71.9248 9.98013C73.2586 10.2228 73.9349 12.6458 73.4353 15.392C72.9357 18.1382 71.4494 20.1677 70.1155 19.9251C68.7817 19.6824 68.1054 17.2594 68.605 14.5132C69.1046 11.767 70.5909 9.73746 71.9248 9.98013Z"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M7.33364 10.3687C7.33364 10.3687 4.35972 12.1499 3.58872 14.9331C2.81772 17.7163 3.58872 20.9448 3.69889 21.3901C3.80906 21.8354 3.58872 23.1713 3.91914 23.8393C4.24956 24.5073 8.98581 28.9604 14.4931 29.851C20.0004 30.7416 26.8295 29.0717 26.8295 29.0717C26.8295 29.0717 23.9915 16.4893 35.0904 14.4878C41.7266 13.291 43.7919 21.5014 42.9107 24.2846C45.6644 23.6166 63.9485 18.1616 65.1601 17.8276C66.3717 17.4936 67.1427 16.937 67.2529 15.8237C67.3631 14.7104 68.0239 9.25535 71.5485 8.47602C73.7432 7.99077 74.9928 10.7026 74.5522 13.9311C74.5522 13.9311 78.1573 11.3706 75.8442 3.9116C75.8442 3.9116 75.2935 2.90968 73.9717 2.57568"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default Icon;
